import React from 'react'
import { connect } from 'react-redux';

import services from 'core/services';
import { getCart } from 'content/pages/Cart/Module';
import { Tabs } from './';
import { Welcome } from 'content/components';
import { SearchView } from 'content/views';

export class Layout extends React.Component {
  render() {
    const { searchVisible } = this.props
    const tourViewed = services.storage.get('tour_viewed')

    return (
      <React.Fragment>
        {tourViewed ?
          <Tabs />
          :
          <Welcome
            navigate={this.props.navigate}
          />
        }
      </React.Fragment>
    )
  }
}

export default connect(
  state => ({

  }),
  {
    getCart,
  }
)(Layout)
